import { render, staticRenderFns } from "./ui-loader.vue?vue&type=template&id=64a7d111&scoped=true&"
import script from "./ui-loader.vue?vue&type=script&lang=ts&"
export * from "./ui-loader.vue?vue&type=script&lang=ts&"
import style0 from "./ui-loader.vue?vue&type=style&index=0&id=64a7d111&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7d111",
  null
  
)

export default component.exports